<mat-progress-bar *ngIf="isSaving()" mode="indeterminate" class="sticky progress"></mat-progress-bar>
<div class="container-fluid">
  <div class="row">
    <div class="col-10">
    
    </div>
    <div class="col-2 text-right">
      <button color="primary" mat-raised-button [mat-dialog-close]="true">
        {{ 'close' | translate }}
      </button>
    </div>
  </div>
  <div class="bg-light shadow-sm pt-3 ml-3 col-md-12 pb-4" >
    <div class="row">
      <div class="col-md-12">
        <h1>{{ 'fineManagement.listFine' | translate }}</h1>
      </div>
    </div>

    <div [ngClass]="{'d-none': dataSource?.filteredData.length == 0 || !dataSource?.filteredData }">
      <table mat-table [dataSource]="dataSource">
   
    
        <ng-container matColumnDef="InfractionCategoryName">
          <th mat-header-cell *matHeaderCellDef> {{ 'fineManagement.categoryColumn' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <span>
              <strong>{{ element.InfractionCategoryName }}</strong>
            </span>
            <br>
            <span>{{ element.Description }}</span>
          </td>
        </ng-container>
    
        <ng-container matColumnDef="Total">
          <th mat-header-cell *matHeaderCellDef> Total </th>
          <td mat-cell *matCellDef="let element">
            {{ element.TotalAmount | currency }}
          </td>
        </ng-container>
    
        <ng-container matColumnDef="Checked">
          <th mat-header-cell *matHeaderCellDef> Alegar </th>
          <td mat-cell *matCellDef="let element">
            <div class="d-flex flex-row">
              <mat-checkbox color="primary" class="ml-4" (change)="checkAlegato($event, element)"  [(ngModel)]="element.Checked" ></mat-checkbox>
            </div>
          </td>
        </ng-container>
    
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    
      </table>

      <mat-form-field appearance="outline" class="w-100" >
        <mat-label>Razón de disputa</mat-label>
        <textarea type="text" matInput [(ngModel)]="note" class="form-control" rows="5"></textarea>
      </mat-form-field>
  
  
      <button 
                mat-flat-button
                (click)="save(true)"
                color="primary"
                style="min-height: 40px;"
                [class.spinner]="isLoadingFine">
                <span  [ngClass]="{'opacity': isLoadingFine}">
                    {{'plantaGasForm.save' | translate }}
                </span>
      </button>
      
      <ng-container *ngIf="dataSource?.filteredData.length > 10">
        <mat-paginator #paginator [length]="length" [disabled]="working.isWorking"
          [hidden]="paginator.length <= pageSize" [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 20]"
          (page)="managePaging($event)" showFirstLastButtons>
        </mat-paginator>
      </ng-container>

   
    </div>
    
 

    
    <!-- <div class="pt-2" *ngIf="this.dataSource.data.length > 0">
      <h2 class="title-total">{{ 'fineManagement.totalFineTable' | translate }} {{ getTotalCost() | currency }}
      </h2>
    </div> -->
    <div class="col-12" *ngIf="dataSource?.filteredData.length == 0">
      <h4>{{ 'fineManagement.noneFound' | translate }}</h4>
    </div>
  </div>
</div>